import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyB716_k2cVjkkJJ5HlEea9ecjn7kQERzcs",
  authDomain: "venue-report-card.firebaseapp.com",
  projectId: "venue-report-card",
  storageBucket: "venue-report-card.firebasestorage.app",
  messagingSenderId: "468894609476",
  appId: "1:468894609476:web:1fbfb7033f6ca205d20c11",
  measurementId: "G-Z4PXPK1QQ9"
};

// Initialize Firebase
console.log('🔧 Initializing Firebase with config:', firebaseConfig);
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Auth and Firestore (production)
console.log('🔐 Initializing Auth and Firestore in production mode');
const auth = getAuth(app);
const db = getFirestore(app);

// Initialize Functions
console.log('⚡ Initializing Functions');
const functions = getFunctions(app, 'us-central1');

// Environment detection
const isLocalhost = window.location.hostname === 'localhost' || 
                   window.location.hostname === '127.0.0.1' ||
                   window.location.hostname.includes('localhost:19006');

// Connect to emulators in development (Functions only)
if (isLocalhost) {
  try {
    console.log('🔧 Development environment detected - connecting to Functions emulator only');
    connectFunctionsEmulator(functions, '127.0.0.1', 5002);
    console.log('✅ Connected to Functions emulator on port 5002');
  } catch (error) {
    console.error('❌ Error connecting to Functions emulator:', error);
  }
} else {
  console.log('🚀 Production environment - using all production services');
}

export { 
  app, 
  analytics, 
  auth, 
  db, 
  functions,
  isLocalhost 
}; 